
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/availability",
      function () {
        return require("private-next-pages/availability.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/availability"])
      });
    }
  